module.exports = __webpack_public_path__ + "img/1.574a3c5c.png";